export const useCdnUrl = (link) => {
  const config = useRuntimeConfig()
  const url = `/cs/cpsite.html?url=${config.app.cdnURL}${link.replace(/^\//, '')}`
  return url
}
